import React from 'react'

const Segment = ({ content, diagnosis, onSelected, type }) => {
    let c = content;
    let answerSelected = (event) => {
        let value = event.currentTarget.attributes['value'].value;
        let selected = event.currentTarget.attributes['isSelected'].value;
        let disabled = event.currentTarget.attributes['isDisabled'].value;
        if (disabled === "true") {
            return;
        }

        if (selected == "true") {
            onSelected(c.id, { text: "" });
        } else {
            onSelected(c.id, { text: value });
        }
    }

    let isSelected = (c, o) => {
        return c.value === (o.value || o.text);
    }
    let isEnabled = (o) => {
        return o.enabled !== false;
    }

    const choicesClasses =
        c.type == "segment" || (c.choices.length == 0)
            ? "segmented-options-" + c.choices.length
            : "segmented-options-vertical segmented-options-vertical-" +
            c.choices.length;

    return (
        <div className={"question "}>
            <div className={ " segmented-options " + choicesClasses}>
                {c.choices.map((o) => {
                    return (
                        <label onClick={answerSelected}
                            key={o.text}
                            isSelected={isSelected(c, o) ? "true" : "false"}
                            isDisabled={!isEnabled(o) ? "true" : "false"}
                            value={o.value || o.text}
                            className={`
                        form-control
                        ${isSelected(c, o) ? "selected" : ""}
                        ${isEnabled(o) ? "" : "disabled"}`
                            } >{o.text}</label>
                    );
                })}
            </div>
        </div>)
};

export default Segment